import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/app/[slug]/components/TableofContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/mykare-blog-web/app/home/components/blogCard/SocialShare.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/mykare-blog-web/components/AuthorHoverContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/mykare-blog-web/components/DelayedFormPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogBody"] */ "/home/ubuntu/mykare-blog-web/components/DynamicText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/mykare-blog-web/components/FactCheckHoverContainer.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/components/GenericForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/mykare-blog-web/components/MedVerifiedByContainer.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/components/RelatedArticleWithSlider.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/public/BlogDetails/ad@3x copy.webp");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/public/BlogDetails/ad@3x.webp");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/public/BlogDetails/Check.svg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/public/BlogDetails/tick@2x.png");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/public/formpopup/consultationImg.webp");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/mykare-blog-web/public/homePage/FeatureImage.webp");
